import PropTypes from 'prop-types';
import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Close } from '@mui/icons-material';
import useIsMobile from 'lib/useIsMobile';
import Tip1 from 'assets/Tip1.png';
import Image from 'components/Image';
import CredMD from 'assets/Cred-md.png';
import CredSM from 'assets/Cred-sm.png';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';

const styles = {
  card: {
    backgroundColor: 'white',
    overflow: 'scroll',
  },
  bulbIconStyle: {
    height: '25px',
    width: '25px',
    display: 'inline-block',
    marginRight: '2%',
  },
  link: {
    color: '#0076BB',
  },
  scoreIcon: {
    width: '12px',
    height: '12px',
    verticalAlign: 'baseline',
    position: 'relative',
    top: '3px',
  },
  scoreIconSM: {
    width: '9px',
    height: '9px',
    verticalAlign: 'baseline',
  },
  alignFlex: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    // marginTop: 20,
  },
};

const DashboardWhatisThisDialogue = ({ open, onCancel }) => {
  const mobile = useIsMobile();
  const btnStyle = makeStyles();
  return (
    <Dialog modal onRequestClose={onCancel} open={open}>
      <Card style={styles.card}>
        <Close
          style={{
            color: '#000',
            marginLeft: 20,
            marginTop: 12,
            cursor: 'pointer',
          }}
          onClick={onCancel}
        />
        <CardHeader
          titleStyle={{
            fontWeight: '700 !important',
            fontSize: '16px !important',
            color: '#0076BB !important',
            fontFamily: 'NewOrderBold !important',
          }}
          title={(
            <span style={styles.alignFlex}>
              What is Ripple Street Cred&nbsp;
              <Image
                alt='up'
                showLoading={false}
                src={CredMD}
                style={styles.scoreIcon}
              />
              , anyways?{' '}
            </span>
          )}
        />
        <CardText
          noTopPadding
          style={{
            fontWeight: '400 !important',
            fontSize: '14px !important',
            color: '#000000',
            fontFamily: 'NiveauGroteskRegular',
          }}
        >
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: '400 !important',
              fontSize: '14px !important',
              marginBottom: 10,
              textAlign: 'justify',
              lineHeight: '20px',
            }}
          >
            Ripple Street Cred&nbsp;
            <Image
              alt='up'
              showLoading={false}
              src={CredSM}
              style={styles.scoreIconSM}
            />{' '}
            is a way to track your Ripple Street experience! We want to give
            community members like you more insight into how your actions affect
            your Ripple Street standing.
          </div>

          <div
            style={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '14px',
              marginBottom: 10,
              lineHeight: '20px',
            }}
          >
            This is new for us, so we appreciate your patience as we test and
            test again to make sure our calculations are right before we move
            out of Beta. We appreciate your feedback along the way!{' '}
            <strong>
              If you have suggestions on how to make this new feature better,
              email us at
              <a style={styles.link} href='mailto:beta@ripplestreet.com'>
                &nbsp;beta@ripplestreet.com
              </a>
              .
            </strong>
          </div>

          <div
            style={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '14px',
              marginBottom: 10,
            }}
          >
            How do you increase your Cred? Glad you asked!
          </div>
          <ListItem button style={styles.listItem}>
            <ListItemText
              style={{
                padding: '2%',
                background: '#F5F5F5',
                border: '1px solid #ACACAC',
                borderRadius: '5px',
              }}
            >
              <div
                style={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '14px',
                  display: 'flex',
                  marginBottom: '1%',
                }}
              >
                <img src={Tip1} alt='light' style={styles.bulbIconStyle} />
                <span style={{ display: 'inline-block' }}>
                  <b>
                    Every application you complete increases your Cred rating.
                  </b>
                </span>
              </div>
              <div
                style={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '14px',
                  display: 'flex',
                  marginBottom: '1%',
                }}
              >
                <img src={Tip1} alt='light' style={styles.bulbIconStyle} />
                <span style={{ display: 'inline-block' }}>
                  <b>Every activity you complete increases your Cred rating.</b>
                </span>
              </div>
              <div
                style={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '14px',
                  display: 'flex',
                  marginBottom: '1%',
                }}
              >
                <img src={Tip1} alt='light' style={styles.bulbIconStyle} />
                <span style={{ display: 'inline-block' }}>
                  <b>
                    Every activity you do not complete decreases your Cred
                    rating.
                  </b>
                </span>
              </div>
            </ListItemText>
          </ListItem>
          <Button
            variant='contained'
            color='primary'
            size='small'
            className={btnStyle.button}
            style={{
              background: '#0076BB',
              position: 'relative',
              left: mobile ? '40%' : '44%',
              borderRadius: '20px',
              marginBottom: '2%',
            }}
            onClick={() => {
              onCancel();
            }}
          >
            OKAY!
          </Button>
        </CardText>
      </Card>
    </Dialog>
  );
};

DashboardWhatisThisDialogue.propTypes = {
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default DashboardWhatisThisDialogue;
